import { SEGMENTS } from "@/constant/constantsThrougoutProject";
import userService from "@/endpoints/userService";
import { createSegmentAfterValidation } from "@/store/slices/segments/segments.thunk";
import type { AppDispatch, RootState } from "@/store/store";
import { dequal } from "dequal";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { updateUrlParams } from "@/utils/url";

const ValidateSegment = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const userSegments = useSelector(
    (state: RootState) => state.activeGroup.segments.segments.ids,
    dequal,
  );

  const userSelectedMarket = useSelector(
    (state: RootState) => state.userSelection.market,
    dequal,
  ) as number;

  const allMarketDetails = useSelector(
    (state: RootState) => state.activeGroup.markets,
    dequal,
  );

  const userSelectedMarketCode: string[] = useMemo(
    () =>
      [userSelectedMarket]
        ?.map((marketId: number) => {
          const currMarket = allMarketDetails.markets.entities[marketId];
          return currMarket?.identity;
        })
        .filter((market): market is string => !!market),
    [userSelectedMarket, allMarketDetails.markets.entities],
  );

  const [notValidatedYet, setNotValidatedYet] = useState(true);
  const location = useLocation();

  useEffect(() => {
    if (userSegments?.length > 0 && notValidatedYet && userSelectedMarket) {
      const searchParams = new URLSearchParams(location.search);
      const segmentsFromURL = searchParams.getAll(SEGMENTS)?.map(Number) || [];
      const invalidSegmentsFromUrl = segmentsFromURL?.filter(
        (segment: number) => !userSegments?.includes(segment),
      );

      if (invalidSegmentsFromUrl?.length > 0) {
        validateAndCreateSegment(invalidSegmentsFromUrl);
        setNotValidatedYet(false);
      }
    }
  }, [userSegments, userSelectedMarket]);

  async function validateAndCreateSegment(invalidSegments: number[]) {
    const response = (await userService.segments.validateSegment(
      [userSelectedMarket],
      invalidSegments,
    )) as { segmentId: number; marketId: number }[];

    const validSegmentIds = response.map((item) => item.segmentId);

    if (validSegmentIds.length > 0) {
      dispatch(
        createSegmentAfterValidation({
          marketIds: [userSelectedMarket],
          marketCodes: userSelectedMarketCode,
          segmentIds: validSegmentIds,
        }),
      ).then((response) => {
        if (
          response.payload &&
          typeof response.payload !== "string" &&
          response.payload.segments
        ) {
          const searchParams = new URLSearchParams(location.search);
          const segmentsFromURL =
            searchParams.getAll(SEGMENTS)?.map(Number) || [];
          updateUrlParams(
            {
              [SEGMENTS]: [
                ...new Set([...segmentsFromURL, ...validSegmentIds]),
              ],
            },
            navigate,
          );
        }
      });
    }
  }
  return null;
};

export default ValidateSegment;
